import { ChangeDetectorRef, Input, Directive, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseProjectComponent } from '@layouts/default/layouts/logged/pages/project/components/base-project.component';
import { ProjectsSort } from '@shared/interfaces/project/projects-sort.interface';

@Directive()
export class AbstractSortProjectsComponent extends BaseProjectComponent implements OnInit {
  @Input() correctForm: UntypedFormGroup = new UntypedFormGroup({});
  @Input() helpukraine: boolean;
  projectType: string;
  sortOptions: ProjectsSort[] = [];
  initValue: string = 'newest';
  allSortingOptionsPages: string[] = ['projects', 'ended', 'verified'];

  constructor(protected activatedRoute: ActivatedRoute, protected _cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.getRouteData();
    this.translateSortOptions(this.projectType);
    // this.translateSortOptions();
    const sub = this.languageService.langChangeEmitter.subscribe(() => {
      setTimeout(() => this.translateSortOptions(this.projectType), 100);
      this._cdr.detectChanges();
    });
    this.someSubscriptions.add(sub);
  }

  getRouteData(): void {
    let currentSnapshot = this.route.snapshot;
    // loop through children snapshots to find correct data object
    while (currentSnapshot.data['type'] === undefined) {
      currentSnapshot = currentSnapshot.children[0];
    }
    this.projectType = currentSnapshot.data.type;
  }

  translateSortOptions(projectType: string): void {
    if (this.helpukraine) {
      setTimeout(() => {
        this.sortOptions = [
          { name: this.translate.instant('PROJECTS.SORT_OPTIONS.newest'), value: 'newest' },
          {
            name: this.translate.instant('PROJECTS.SORT_OPTIONS.most_donated'),
            value: 'most_donated',
          },
        ];
      });
    } else {
      setTimeout(this.checkUrlParams.bind(this), 100);
      this.sortOptions = [];
      setTimeout(() => {
        this.sortOptionsConfig(projectType);
      });
    }
  }

  sortOptionsConfig(projectType: string): void {
    this.allSortingOptionsPages.indexOf(projectType) > -1
      ? (this.sortOptions = [
          { name: this.translate.instant('PROJECTS.SORT_OPTIONS.newest'), value: 'newest' },
          {
            name: this.translate.instant('PROJECTS.SORT_OPTIONS.garbage_bag_count'),
            value: 'garbage_bag_count',
          },
          {
            name: this.translate.instant('PROJECTS.SORT_OPTIONS.most_donated'),
            value: 'most_donated',
          },
          { name: this.translate.instant('PROJECTS.SORT_OPTIONS.ending'), value: 'end_date' },
        ])
      : (this.sortOptions = [
          { name: this.translate.instant('PROJECTS.SORT_OPTIONS.created'), value: 'created' },
          { name: this.translate.instant('PROJECTS.SORT_OPTIONS.popular'), value: 'popular' },
          {
            name: this.translate.instant('PROJECTS.SORT_OPTIONS.most_recent'),
            value: 'most_recent',
          },
        ]);
    this._cdr.detectChanges();
  }

  sortOptionsConfigError(error: Error): void {
    this.toast.error(
      this.translate.instant('PROJECTS.cant_get_sort_options'),
      this.translate.instant('PROJECTS.sort_options_error')
    );
  }

  get currentLang() {
    return this.storage.get('lang');
  }

  get s() {
    return this.correctForm.get('order_by');
  }

  onSortChange(): void {
    this.updateParams();
  }

  updateParams(): void {}

  checkUrlParams(): void {}
}
